import { useEffect, useRef, useState } from 'react'

import { EVENT_NAME_RESIZE, EVENT_NAME_SCROLL } from '../../constants/event'
import { useAnimationFrame } from '../useAnimationFrame'

import { isStickyBottomElementStuck } from './useStickyBottomShadow.utils'

export function useStickyBottomShadow() {
  const [isStuck, setIsStuck] = useState(false)

  const ref = useRef(null)

  function handleUpdate() {
    if (ref.current) {
      setIsStuck(isStickyBottomElementStuck(ref.current))
    }
  }

  const [scheduleUpdate, cancelUpdate] = useAnimationFrame(handleUpdate)

  useEffect(() => {
    const element = ref.current

    if (element) {
      const observer = new ResizeObserver(scheduleUpdate)

      observer.observe(element.parentElement)

      document.addEventListener(EVENT_NAME_SCROLL, scheduleUpdate, {
        capture: true,
        passive: true,
      })
      window.addEventListener(EVENT_NAME_RESIZE, scheduleUpdate)

      return () => {
        cancelUpdate()
        observer.disconnect()

        document.removeEventListener(EVENT_NAME_SCROLL, scheduleUpdate, true)
        window.removeEventListener(EVENT_NAME_RESIZE, scheduleUpdate)
      }
    }
  }, [])

  return { isStuck, ref }
}
